module.exports = __webpack_public_path__ + "img/bg.913eb3ed.png";